const state = {
    currentUser: null
}

const getters = {
    currentLoginName: state => state.currentUser ? state.currentUser.loginName : null,
};
const actions = {
    getCurrentUser(context) {
        context.dispatch("api/get",
            {
                url: process.env.VUE_APP_EM_ADMIN_URL + "/emAclUser/currentUser"
            },
            {root: true}).then(data => {
            if (data) {
                context.commit('setCurrentUser', data);
            } else {
                context.dispatch('clear');
            }
        })
    },

    clear(context) {
        context.commit('setCurrentUser', null);
    },
};
const mutations = {
    setCurrentUser(state, user) {
        state.currentUser = user;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
